import { useCallback, useMemo } from 'react';
import { useCountryList } from 'src/ui/shared/hooks/country-list.hook';

export const useCountryOption = (countryCode: string | undefined) => {
    const { list: countryList } = useCountryList();
    const countryOption = useMemo(
        () => countryList?.find(i => i.code === countryCode),
        [countryList, countryCode]
    );
    return countryOption;
};

export const useGetCountryOption = () => {
    const { list: countryList } = useCountryList();
    const getCountryOption = useCallback(
        (countryCode: string) => {
            return countryList.find(x => x.code === countryCode);
        },
        [countryList]
    );

    return getCountryOption;
};
